import React from 'react';
import { usePagination } from 'hooks';

export default Component => props => {
    const [page, onPageChange] = usePagination();
    return <Component {...props} onPageChange={onPageChange} page={page} />;
};
